import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBrokenChainLink2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="broken-chain-link-2,unlink"><path d="M15.75 17.25H22.25V6.75H15.75M8.25 17.25H1.75V6.75H8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10.25 4.25L9.25 1.75M13.75 4.25L14.75 1.75M10.25 19.75L9.25 22.25M13.75 19.75L14.75 22.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBrokenChainLink2;
